import { DataProvider } from './DataProvider';
import prepareData from './prepare-data';

export default function standardStepQuiz(quiz) {
    return new DataProvider(prepareData(JSON.parse(JSON.stringify(quiz.questions))));
}
